import { StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';

const KIT_CELL_WIDTH = 28;
const CENTER_BLOCK_WIDTH = 76;

export function getMatchHubH2HMeetingRowStyles(theme: Theme) {
  return StyleSheet.create({
    meetingBlock: {
      paddingVertical: theme.spacing.md,
      borderBottomWidth: StyleSheet.hairlineWidth,
      borderBottomColor: theme.gray[200],
    },
    meetingBlockLast: {
      borderBottomWidth: 0,
    },
    topMetaRow: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      marginBottom: theme.spacing.sm,
    },
    dateLine: {
      ...theme.typography.labelSmall,
      fontWeight: '600',
      color: theme.gray[800],
      flex: 1,
      paddingRight: theme.spacing.sm,
    },
    competitionPill: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 6,
      maxWidth: '55%',
      paddingVertical: 5,
      paddingHorizontal: theme.spacing.sm,
      borderRadius: theme.borderRadius.md,
      backgroundColor: theme.gray[100],
      borderWidth: StyleSheet.hairlineWidth,
      borderColor: theme.gray[200],
    },
    competitionPillText: {
      ...theme.typography.caption,
      fontSize: 10,
      fontWeight: '800',
      letterSpacing: 0.6,
      color: theme.gray[600],
      flexShrink: 1,
    },
    meetingScoreboardRow: {
      flexDirection: 'row',
      alignItems: 'center',
      minHeight: 56,
    },
    nameColumnLeft: {
      flex: 1,
      minWidth: 0,
      justifyContent: 'center',
      alignItems: 'flex-end',
      paddingRight: 6,
      alignSelf: 'stretch',
    },
    nameColumnRight: {
      flex: 1,
      minWidth: 0,
      justifyContent: 'center',
      alignItems: 'flex-start',
      paddingLeft: 6,
      alignSelf: 'stretch',
    },
    kitCell: {
      width: KIT_CELL_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      alignSelf: 'stretch',
    },
    teamName: {
      fontSize: 14,
      fontWeight: '600',
      color: theme.gray[800],
      flexShrink: 1,
      lineHeight: 18,
      maxHeight: 36,
      textAlign: 'left',
    },
    teamNameTowardCenterLeft: {
      textAlign: 'right',
    },
    centerBlock: {
      width: CENTER_BLOCK_WIDTH,
      alignItems: 'center',
      justifyContent: 'center',
      paddingHorizontal: 4,
      alignSelf: 'stretch',
    },
    centerBlockWithScore: {
      marginTop: -8,
    },
    centerStatus: {
      fontSize: 10,
      fontWeight: '700',
      color: theme.gray[500],
      marginBottom: 2,
    },
    centerScore: {
      fontSize: 15,
      fontWeight: '800',
      color: theme.gray[800],
    },
  });
}
